<!-- @format -->
@if (shouldShowBackButton()) {
	<div class="btsr searchbtn-mobile hmf-subheader-bold-l">
		<button
			class="hmf-py-0"
			hmf-button
			[text]="backButtonText()"
			[title]="backButtonText()"
			icon="chevron-left"
			variant="tertiary"
			[dataEm]="dataEmText()"
			id="btsr-button"
			(click)="backToSearchResults()"></button>
	</div>
}
